export default __webpack_public_path__ + "5d86e31.png";